import React from "react";
import { ThemeIcon } from "@mantine/core";
import { AuthLayout } from "../../../components/AuthLayout";
import { BRAND_MEDIUM } from "../../../theme/brand";

const VENDOR_POINTS = [
  "Browse open tenders and download tender documents",
  "Submit bids before the deadline from anywhere",
  "Track every bid from your vendor portal",
];

type VendorAuthLayoutProps = {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  back?: { label: string; to: string };
  children: React.ReactNode;
};

/** AuthLayout preset for the vendor sign-in, registration and account recovery pages. */
export function VendorAuthLayout({
  back = { label: "Back to vendor portal", to: "/vendor" },
  ...props
}: VendorAuthLayoutProps) {
  return (
    <AuthLayout
      product="HMH Vendor Portal"
      panelEyebrow="Hulhumalé Hospital · Suppliers"
      panelTitle="Bid on hospital tenders online"
      panelPoints={VENDOR_POINTS}
      back={back}
      {...props}
    />
  );
}

/** Large round status icon for confirmation screens. */
export function StatusIcon({ color = BRAND_MEDIUM, children }: { color?: string; children: React.ReactNode }) {
  return (
    <ThemeIcon size={56} radius="xl" variant="light" color={color}>
      {children}
    </ThemeIcon>
  );
}
